import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule, FormBuilder, Validators } from '@angular/forms';
import { Router, RouterLink } from '@angular/router';
import { PasswordService } from '../../../core/services/password.service';

@Component({
  selector: 'app-forgot-password',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, RouterLink],
  templateUrl: './forgot-password.component.html',
  styleUrl: './forgot-password.component.scss'
})
export class ForgotPasswordComponent {
  private fb = inject(FormBuilder);
  private passwordService = inject(PasswordService);
  private router = inject(Router);

  forgotForm = this.fb.group({
    email: ['', [Validators.required, Validators.email]]
  });

  isLoading = false;
  message = '';
  isSuccess = false;

  onSubmit() {
    if (this.forgotForm.valid) {
      this.isLoading = true;
      this.message = '';
      const email = this.forgotForm.value.email!;
      this.passwordService.forgotPassword(email).subscribe({
        next: () => {
          this.isLoading = false;
          this.isSuccess = true;
          this.message = `Success! Your email has been sent to ${email}`;
          // Redirect to login after 5 seconds
          setTimeout(() => {
            this.router.navigate(['/login']);
          }, 5000);
        },
        error: () => {
          this.isLoading = false;
          this.isSuccess = false;
          this.message = 'Something went wrong. Please try again.';
        }
      });
    }
  }
}
